<template>
  <div>
    <v-card height="100%" :loading="getCurrentLeadLoading">
      <v-card-title>
        Current Provider
        <v-spacer></v-spacer>
        <v-btn class="mt-0" color="secondary" x-small @click="dialogOpen = true"><v-icon small>edit</v-icon></v-btn>
      </v-card-title>

      <v-card-text v-if="!getCurrentLeadLoading">
        <v-row>
          <v-col>
            <p class="mb-1 text-caption">Provider</p>
            <p><b>{{getCurrentLead.current_provider | customPlaceholder('-')}}</b></p>

            <p class="mb-1 text-caption">Contract end date</p>
            <p><b>{{getCurrentLead.current_contract_end_date | customPlaceholder('-')}}</b></p>

            <p class="mb-1 text-caption">Monthly</p>
            <p><b>{{getCurrentLead.current_monthly_price | formatCurrency | customPlaceholder('-')}}</b></p>

            <p class="mb-1 text-caption">Speed (Mbps)</p>
            <p><b>{{getCurrentLead.current_speed_mbps | customPlaceholder('-')}}</b></p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <CurrentProviderDialog :dialogOpen="dialogOpen" @close-dialog="dialogOpen=false;" />
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import CurrentProviderDialog from './Dialogs/CurrentProviderDialog';

  export default {
    components: {
      CurrentProviderDialog,
    },

    data() {
      return {
        dialogOpen: false
      }
    },

    computed: {
      ...mapGetters('leads', ['getCurrentLead', 'getCurrentLeadLoading']),
    },
  }
</script>

<style lang="scss" scoped>

</style>
